<template>
  <section class="content">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Logística y despacho de ventas</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item"><a href="javascript:void(0)">Home</a></li>
              <li class="breadcrumb-item active">Ventas</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <div class="row align-items-center">
                <div class="col">
                  <h3 class="card-title">Lista de despachos de mercancía</h3>
                </div>
                <div class="col-auto">
                  <button class="btn btn-outline-secondary btn-sm" @click="iniciarTutorial">
                    <i class="fas fa-question-circle"></i> Ayuda
                  </button>
                </div>
              </div>
            </div>
            <div class="card-body">
              <table id="tablaLogistica" class="table table-bordered table-striped w-100">
                <thead>
                  <tr>
                    <th>Venta</th>
                    <th>Cliente</th>
                    <th>Camión</th>
                    <th>Fecha Asig.</th>
                    <th>Fecha Ven.</th>
                    <th>Fecha Ent.</th>
                    <th>Estatus</th>
                    <th style="width: 80px;">Acción</th>
                  </tr>
                </thead>
                <tbody></tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <asignar-despacho-modal ref="asignarDespachoModal" :despacho="despachoSeleccionado"
      :inicialCamion="camionInicialSeleccionado" @despachoAsignado="handleDespachoAsignado"
      @entregaConfirmada="handleEntregaConfirmada" />
  </section>
</template>

<script>
import { ref, onMounted, onBeforeUnmount, nextTick, getCurrentInstance } from "vue";
import api from "@/services/api";
import AsignarDespachoModal from '@/components/AsignarDespachoModal.vue';
import { loading } from '@/plugins/loading';
import { tutorial } from "@/plugins/tutorial";
import 'datatables.net-bs4';

export default {
  name: 'DespachoVentas',
  components: { AsignarDespachoModal },
  setup() {
    const { proxy } = getCurrentInstance();
    const dt = ref(null);
    const despachos = ref([]);
    const despachoSeleccionado = ref(null);
    const camionInicialSeleccionado = ref(null);
    const asignarDespachoModal = ref(null);

    async function obtenerDespachos() {
      try {
        loading.show('Cargando logística...');
        const respuesta = await api.get('/despachoventas');
        despachos.value = (respuesta.data || []);
        await nextTick();
        initDataTable();
      } catch (error) {
        console.error('Error al obtener los despachos:', error);
      } finally {
        loading.hide();
      }
    }

    function initDataTable() {
      if (!window.$ || !$.fn.DataTable) return;

      if (dt.value) {
        dt.value.clear().rows.add(despachos.value).draw();
        return;
      }

      dt.value = window.$("#tablaLogistica").DataTable({
        data: despachos.value,
        createdRow: function (row, data) {
          if (data.status === 'anulado') {
            $(row).addClass('table-danger');
          }
        },
        columns: [
          { data: "venta.numcontrol" },
          { data: "venta.nombre_cliente" },
          {
            data: "almacen.descripcion",
            defaultContent: '<span class="badge badge-secondary">Pendiente</span>'
          },
          {
            data: "venta.fecha_entrega",
            defaultContent: 'Pendiente'
          },
          { data: "venta.fecha_venta" },
          {
            data: "venta.fecha_entrega",
            defaultContent: 'Indefinida'
          },
          {
            data: "status",
            render: (data) => `<span class="badge badge-info">${data}</span>`
          },
          {
            data: null,
            orderable: false,
            render: (data, type, row) => {
              if (row.status === 'anulado') return '';
              const isDisabled = (row.status === 'entregado' || row.status === 'pendiente') ? 'disabled' : '';
              const showConfirmBtn = row.almacen && row.almacen.id;
              const label = row.status === 'entregado' ? 'Entregado' : 'Confirmar Entrega';
              return `
                <div class="d-flex flex-column gap-1">
                  <a href="/despacho/confirmar/${row.venta.id}" class="btn btn-primary btn-sm shadow-sm mb-1 ${isDisabled} ${!showConfirmBtn ? 'd-none' : ''}">
                    <i class="fas fa-truck-loading mr-1"></i> ${label}
                  </a>
                  <button class="btn btn-warning btn-sm btn-accion" data-id="${row.id}">
                    Asignar Camión
                  </button>
                </div>`;
            }
          }
        ],
        responsive: true,
        autoWidth: false,
        order: [[4, "asc"]], // Fecha venta ascendente
        language: { url: "https://cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json" },
        dom: '<"row mb-3"<"col-12 col-md-6"f>>t<"row mt-3"<"col-12 text-center"i>><"row"<"col-12 d-flex justify-content-center"p>>'
      });

      window.$("#tablaLogistica tbody").on("click", "button.btn-accion", function () {
        const id = window.$(this).data("id");
        const despacho = despachos.value.find(d => d.id === id);
        if (despacho) abrirModalDespacho(despacho);
      });
    }

    function abrirModalDespacho(despacho) {
      despachoSeleccionado.value = despacho;
      camionInicialSeleccionado.value = despacho.almacen ? despacho.almacen.id : null;
      nextTick(() => {
        if (asignarDespachoModal.value) asignarDespachoModal.value.abrirModal();
      });
    }

    async function descargarPDF() {
      try {
        loading.show('Generando reporte...');
        const response = await api.get("/pdf/logistica", { responseType: 'blob' });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Logistica_Ventas.pdf');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        proxy.$toast({ icon: 'error', title: 'Error al generar PDF' });
      } finally {
        loading.hide();
      }
    }

    function iniciarTutorial() {
      const steps = [
        { element: '#tablaLogistica', title: 'Listado de Logística', text: 'Aquí puedes ver las ventas pendientes por entregar y su camión asignado.', position: 'top' },
        { element: '.btn-accion', title: 'Gestionar Despacho', text: 'Haz clic aquí para asignar un camión o confirmar la entrega.', position: 'left' }
      ];
      tutorial.start(steps);
    }

    onMounted(() => {
      obtenerDespachos();
      tutorial.set(iniciarTutorial);
    });

    onBeforeUnmount(() => {
      if (dt.value) dt.value.destroy();
      tutorial.set(null);
    });

    return {
      despachos,
      despachoSeleccionado,
      camionInicialSeleccionado,
      asignarDespachoModal,
      obtenerDespachos,
      abrirModalDespacho,
      descargarPDF,
      iniciarTutorial,
      handleDespachoAsignado(data) {
        proxy.$toast({ icon: 'success', title: 'Despacho actualizado' });
        obtenerDespachos();
      },
      handleEntregaConfirmada(data) {
        proxy.$toast({ icon: 'success', title: 'Entrega confirmada' });
        obtenerDespachos();
      }
    };
  }
};
</script>
<style scoped>
.card-title {
  font-weight: 600;
}
</style>